import { SHOW_MODAL, HIDE_MODAL } from './actionTypes';

export function showModal(modal) {
  return {
    type: SHOW_MODAL,
    modal: {
      ...modal,
      showModal: true
    }
  };
}

export function hideModal(modal) {
  return {
    type: HIDE_MODAL,
    modal: {
      ...modal,
      showModal: false
    }
  };
}
